import React from 'react';
import { Grid, Typography, Chip } from '@mui/material';

const PatientInfo = ({ patient }) => {
  const calculateAge = (dateOfBirth) => {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return age;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>Informations Personnelles</Typography>
        <Typography><strong>Nom:</strong> {patient.lastName}</Typography>
        <Typography><strong>Prénom:</strong> {patient.firstName}</Typography>
        <Typography><strong>Âge:</strong> {calculateAge(patient.dateOfBirth)} ans</Typography>
        <Typography><strong>Genre:</strong> {patient.gender === 'M' ? 'Homme' : patient.gender === 'F' ? 'Femme' : 'Autre'}</Typography>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>Coordonnées</Typography>
        <Typography><strong>Téléphone:</strong> {patient.phone}</Typography>
        <Typography><strong>Contact d'urgence:</strong> {patient.emergencyContact}</Typography>
        <Typography><strong>Téléphone urgence:</strong> {patient.emergencyPhone}</Typography>
      </Grid>
    </Grid>
  );
};

export default PatientInfo;